/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  ActiveIncomingCallResponse,
  SalesCallLiveStatus,
} from "../models/index";
import {
  ActiveIncomingCallResponseFromJSON,
  ActiveIncomingCallResponseToJSON,
  SalesCallLiveStatusFromJSON,
  SalesCallLiveStatusToJSON,
} from "../models/index";

export interface SalesCallLiveStatusRequest {
  companyNoteId: string;
}

/**
 *
 */
export class DialpadCallsApi extends runtime.BaseAPI {
  /**
   * Polled by Hubble so a sales rep sees their active incoming call (who\'s calling, which company) and can log it while it\'s happening. Scoped to the logged-in rep.
   * Polled by Hubble so a sales rep sees their active incoming call (who\'s calling, which company) and can log it while it\'s happening.
   */
  async activeIncomingCallRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ActiveIncomingCallResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/dialpad-calls/active-incoming`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ActiveIncomingCallResponseFromJSON(jsonValue),
    );
  }

  /**
   * Polled by Hubble so a sales rep sees their active incoming call (who\'s calling, which company) and can log it while it\'s happening. Scoped to the logged-in rep.
   * Polled by Hubble so a sales rep sees their active incoming call (who\'s calling, which company) and can log it while it\'s happening.
   */
  async activeIncomingCall(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ActiveIncomingCallResponse> {
    const response = await this.activeIncomingCallRaw(initOverrides);
    return await response.value();
  }

  /**
   * Live status of the Dialpad call behind a sales-call note, polled by the Log Sales Call dialog: whether the call has ended, whether Dialpad\'s AI recap and action items have arrived, and the recap text itself.
   * Live status of the Dialpad call behind a sales-call note, polled by the Log Sales Call dialog: whether the call has ended, whether Dialpad\'s AI recap and action items have arrived, and the recap text itself.
   */
  async salesCallLiveStatusRaw(
    requestParameters: SalesCallLiveStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SalesCallLiveStatus>> {
    if (requestParameters["companyNoteId"] == null) {
      throw new runtime.RequiredError(
        "companyNoteId",
        'Required parameter "companyNoteId" was null or undefined when calling salesCallLiveStatus().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["companyNoteId"] != null) {
      queryParameters["companyNoteId"] = requestParameters["companyNoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/dialpad-calls/sales-call-live`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      SalesCallLiveStatusFromJSON(jsonValue),
    );
  }

  /**
   * Live status of the Dialpad call behind a sales-call note, polled by the Log Sales Call dialog: whether the call has ended, whether Dialpad\'s AI recap and action items have arrived, and the recap text itself.
   * Live status of the Dialpad call behind a sales-call note, polled by the Log Sales Call dialog: whether the call has ended, whether Dialpad\'s AI recap and action items have arrived, and the recap text itself.
   */
  async salesCallLiveStatus(
    requestParameters: SalesCallLiveStatusRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SalesCallLiveStatus> {
    const response = await this.salesCallLiveStatusRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
